module.exports = __webpack_public_path__ + "img/paternity.54556bd7.png";